import { Facebook, Instagram, Youtube, Twitter, Linkedin, Star } from "lucide-react";

const SocialMediaLinks = ({ className = "" }) => {
  const socialLinks = [
    {
      name: "Facebook",
      url: "https://www.facebook.com/share/1D8ugiC4oz/?mibextid=wwXIfr",
      icon: Facebook,
      color: "#1877F2",
      hoverColor: "hover:bg-blue-600"
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/brandborn_?igsh=MTAxZHl5NjBybGh6Yg==",
      icon: Instagram,
      color: "#E4405F",
      hoverColor: "hover:bg-pink-600"
    },
    {
      name: "YouTube",
      url: "https://youtube.com/@brandborn1?si=GSdlpTpZM_o6PMRI",
      icon: Youtube,
      color: "#FF0000",
      hoverColor: "hover:bg-red-600"
    },
    {
      name: "Twitter",
      url: "https://twitter.com/brandborn_",
      icon: Twitter,
      color: "#1DA1F2",
      hoverColor: "hover:bg-blue-400"
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/brandborn1/",
      icon: Linkedin,
      color: "#0A66C2",
      hoverColor: "hover:bg-blue-700"
    },
    {
      name: "Trustpilot",
      url: "https://www.trustpilot.com/evaluate/brandborn.in",
      icon: Star,
      color: "#00B67A",
      hoverColor: "hover:bg-green-600"
    },
    {
      name: "Google Reviews",
      url: "https://g.page/r/CSndT8PcArO0EBM/review",
      icon: Star,
      color: "#4285F4",
      hoverColor: "hover:bg-blue-500"
    }
  ];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {socialLinks.map((social, idx) => {
        const Icon = social.icon;
        return (
          <a
            key={idx}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-gray-800 hover:bg-opacity-80 flex items-center justify-center transition-all duration-300 transform hover:scale-110 ${social.hoverColor}`}
            aria-label={social.name}
            title={social.name}
          >
            <Icon size={16} className="text-white lg:w-[18px] lg:h-[18px]" />
          </a>
        );
      })}
    </div>
  );
};

export default SocialMediaLinks;